<template>
    <Uploader
            @delete="removeObj"
            name="file"
            multiple
            :max-count="item.num"
            :before-read="beforeUpload"
            :after-read="handleUploadChange"
            :file-list="defaultFileList"
    >
        <div v-if="item.style" class="img"></div>
    </Uploader>
</template>

<script>
    let g_object_name_type = "random_name";
    function random_string(len) {
        len = len || 32;
        var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        var maxPos = chars.length;
        var pwd = "";
        for (var i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }
    function get_suffix(filename) {
        var pos = filename.lastIndexOf(".");
        var suffix = "";
        if (pos !== -1) {
            suffix = filename.substring(pos);
        }
        return suffix;
    }
    function calculate_object_name(dir, filename) {
			
        let g_object_name = "";
        if (g_object_name_type === "local_name") {
            g_object_name += "${filename}";
        } else if (g_object_name_type === "random_name") {
            var suffix = get_suffix(filename);
            g_object_name = dir + random_string(10) + suffix;
        }
        return g_object_name;
    }

    import {Uploader} from 'vant';
    import api from '@/api'
    import axios from 'axios';


    export default {
        components: {
            Uploader
        },
        props: {
            item: {
                type: Object
            },
            fileList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            placeholder: {
                type: String,
                default: "点击上传"
            },
            buttonType: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                OSSData: {
                    host: ""
                },
                fileKey: {},
                defaultFileList: [],
                request: ""
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await api.system.ossSignature().then((res) => {
                    this.OSSData = res.data;
                });
            },
            emit() {
                var newVal = [];
                this.defaultFileList.forEach(item => {
                    newVal.push(item.url)
                });
                this.$emit("setUrl", JSON.stringify(newVal), this.item.key_name);
            },
            removeObj: function (info) {
                this.defaultFileList.forEach((item, index) => {
                    if (info.url == item.url) this.defaultFileList.splice(index, 1);
                })
                this.emit();
            },
            async handleUploadChange(info) {
                if (Object.prototype.toString.call(info) === '[object Object]') info = [info]
                let fileList = []
                for(var index in info ){
                    var file = info[index]
                    fileList.push({url: file.content, status: 'uploading', isImage: true})
                    var data = this.getExtraData(file.file);
										console.log('0001000', data)
                    var formdata = new FormData();
                    for (var i in data) {
                        formdata.set(i, data[i]);
                    }
                    formdata.append("file", file.file)
                    await axios({
                        url: this.OSSData.host,
                        method: "post",
                        data: formdata,
                        headers: {'Content-Type': 'multipart/form-data'}
                    }).then((res) => {
                        var {data} = res
                        if (data.Status == 'Ok') {
                            fileList[index]['status'] = 'done';
                            fileList[index]['url'] = this.OSSData.host + "/" + this.fileKey[file.file.name];
                        } else {
                            fileList[index]['status'] = 'failed';
                        }
                    })
                }
                this.defaultFileList = this.defaultFileList.concat(fileList);
                this.emit();
            },
            async beforeUpload(e) {
                const expire = this.OSSData.expire * 1000;
                if (expire < Date.now()) {
                    await this.init();
                }
            },
            getExtraData(file) {
                const {OSSData} = this.$data;
                this.fileKey[file.name] = calculate_object_name(OSSData.dir, file.name);
                
								return {
                    key: this.fileKey[file.name],
                    OSSAccessKeyId: OSSData.accessid,
                    policy: OSSData.policy,
                    Signature: OSSData.signature,
                    callback: OSSData.callback
                };
            }
        }
    };
</script>
<style>
  .img{
    background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20220401/1648800292/93143.png);
    background-size: 100%;
    width: 6.9rem;
    height: 2.75rem;
  }
</style>
